import { Box } from "@mui/material"

const validateGrupo= (data) => {

    const response = []
 
    if (!data?.nome > 0)
        response.push(<Box>Digite um nome.</Box>)

    if (!data?.default_name > 0)
        response.push(<Box>Digite um nome default.</Box>)

    if (data?.branch.length === 0)
        response.push(<Box>Selecione uma filial.</Box>)
    
    if (response.length === 0)
        return ''

    return (response)
}

export default validateGrupo